import React, { Component } from 'react';
import { Formik, FieldArray } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import { find } from 'lodash';
import * as constants from '../../constants';
import SecurityMeasuresGrid from './SecurityMeasuresGrid';

import common from '../../../../common';
import core from '../../../core';


const { TextInput, SelectInput, MultiSelectInput, DisplayFormikState } = core;

const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    description: Yup.string().required('*'),
    idDataCategory: Yup.number().integer().required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class ProcessedDataForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            await this.props.onSave(values);
            setSubmitting(false);
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ProcessedDataForm', key);
    }
    onDataCategoryChanged = (id) => {
        let cat = find(this.props.picklists.dataCategories, { 'id': id });
        this.formik.setFieldValue('dataCategoryName',cat.name);
    }

    CreateForm = (props) => {
        //console.log(props);
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>

                <TextInput {...props} name="description" readOnly={userHasReadonlyRights} label={this.label("Description")} formItemLayout={formItemLayout} />
                <SelectInput onSelectionChanged={this.onDataCategoryChanged} {...props} name="idDataCategory" nameField="name" idField="id" items={this.props.picklists.dataCategories} label={this.label("DataCategory")} formItemLayout={formItemLayout} />
                <TextInput {...props} name="itSystemOrStorageLocation" readOnly={userHasReadonlyRights} label={this.label("ItSystemOrStorageLocation")} formItemLayout={formItemLayout} />

                <FieldArray name="securityMeasures"
                    render={arrayHelpers => (
                        <FormItem label={this.label("SecurityMeasures")} {...formItemLayout}>
                            <SecurityMeasuresGrid idProcessedData={props.values.idProcessedData} arrayHelper={arrayHelpers} items={props.values.securityMeasures.map((line, index) => { return { ...line, idx: index } })} />
                        </FormItem>
                    )}
                />

                <FormItem {...tailFormItemLayout}>
                    <Space.Compact className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </Space.Compact>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
                innerRef={p => (this.formik = p)}
            />
        );
    }
}

export default ProcessedDataForm